// Module
var code = "<div class=\"basket-email-content\"> <div class=\"basket-email-content__header\">[[EmailBasketHeader]]</div> <div class=\"basket-email-content__sub-header\">[[EmailBasketSubHeader]]</div> <div class=\"basket-email-content__thank-you\">[[EmailBasketThankYou]]</div> </div>";
// Exports
module.exports = code;